import { Injectable } from "@angular/core";

import { Observable } from "rxjs";

import { AIModel, AIProvider, CreateAIModelDto, UpdateAIModelDto } from "@shared/models/ai-model.model";
import { PaginatedResponse, QueryParams } from "@shared/models/query-params.model";
import { BaseHttpService } from "@shared/services/base-http.service";

@Injectable({
  providedIn: "root"
})
export class AiModelHttpService extends BaseHttpService {
  protected override baseEndpoint = "admin/ai-models";

  /**
   * Get all enabled AI models (Public)
   */
  getAll(queryParams?: QueryParams): Observable<PaginatedResponse<AIModel>> {
    return this.getMany<AIModel>({
      endpoint: "ai-models",
      skipBaseUrl: true,
      queryParams,
      type: AIModel
    });
  }

  // --- Admin Methods ---

  /**
   * Get all AI providers (Admin)
   */
  getProviders(): Observable<AIProvider[]> {
    return this.getManyWithoutPagination<AIProvider>({
      endpoint: "providers",
      type: AIProvider
    });
  }

  /**
   * Get AI model by ID (Admin)
   */
  getById(id: string): Observable<AIModel> {
    return this.get<AIModel>({
      endpoint: id,
      type: AIModel
    });
  }

  /**
   * Create a new AI model (Admin)
   */
  create(data: CreateAIModelDto): Observable<AIModel> {
    return this.post<AIModel>({
      endpoint: "",
      body: data,
      type: AIModel
    });
  }

  /**
   * Update an AI model (Admin)
   */
  update(data: UpdateAIModelDto): Observable<AIModel> {
    return this.patch<AIModel>({
      endpoint: data.id,
      body: data,
      type: AIModel
    });
  }

  /**
   * Delete an AI model (Admin)
   */
  deleteModel(id: string): Observable<void> {
    return this.delete<void>({
      endpoint: id
    });
  }
}
